<template>
  <div class="row">
    <div class="col-12 ">
      <div class="row justify-content-center">
        <div
          class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
        >
          <label class="col-12 col-form-label mb-0">Imprimir Abonos:</label>
          <base-radio
            class="ml-3 mt-0 col-12"
            name="1"
            v-model="payload.imprimirAbono"
            >Sim</base-radio
          >
          <base-radio
            class="ml-3 mt-0 col-12"
            name="0"
            v-model="payload.imprimirAbono"
            >Não</base-radio
          >
        </div>

        <div
          class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
        >
          <label class="col-12 col-form-label mb-0">Imprimir Abonos BH:</label>
          <base-radio
            class="ml-3 mt-0 col-12"
            name="1"
            v-model="payload.imprimirAbonoBH"
            >Sim</base-radio
          >
          <base-radio
            class="ml-3 mt-0 col-12"
            name="0"
            v-model="payload.imprimirAbonoBH"
            >Não</base-radio
          >
        </div>

        <div
          class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
        >
          <label class="col-12 col-form-label mb-0"
            >Imprimir Ocorrências:</label
          >
          <base-radio
            class="ml-3 mt-0 col-12"
            name="1"
            v-model="payload.imprimirOcorrencia"
            >Sim</base-radio
          >
          <base-radio
            class="ml-3 mt-0 col-12"
            name="0"
            v-model="payload.imprimirOcorrencia"
            >Não</base-radio
          >
        </div>

        <div
          class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
        >
          <label class="col-12 col-form-label mb-0"
            >Imprimir Batidas Manuais:</label
          >
          <base-radio
            class="ml-3 mt-0 col-12"
            name="1"
            v-model="payload.imprimirBatidasManuais"
            >Sim</base-radio
          >
          <base-radio
            class="ml-3 mt-0 col-12"
            name="0"
            v-model="payload.imprimirBatidasManuais"
            >Não</base-radio
          >
        </div>
      </div>

      <div class="row justify-content-center mt-4">
        <div
          class="col-12 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
        >
          <label class="col-12 col-form-label mb-0">Imprimir Feriados:</label>
          <base-radio
            class="ml-3 mt-0 col-12"
            name="1"
            v-model="payload.imprimirFeriado"
            >Sim</base-radio
          >
          <base-radio
            class="ml-3 mt-0 col-12"
            name="0"
            v-model="payload.imprimirFeriado"
            >Não</base-radio
          >
        </div>
      </div>
    </div>
    <div class="col-12 row">
      <div class="offset-10 col-2 mt-2">
        <base-button
          :disabled="isLoading"
          type="success"
          class="animation-on-hover"
          @click="salvar()"
          >Salvar</base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
/**
    Tipo 1: Cadastro de Postos
    Tipo 2: Edição de Postos
*/
import { BaseInput } from "../../components/index";
import { Select, Option } from "element-ui";

export default {
  name: "FormParametrizacao",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
  },
  props: {
    parametros: "",
    posto: "",
    isLoading: false,
  },
  data() {
    return {
      payload: {
        setDB: "",
        imprimirAbono: "1",
        imprimirAbonoBH: "1",
        imprimirOcorrencia: "1",
        imprimirBatidasManuais: "1",
        imprimirFeriado: "1",
      },
    };
  },
  mounted() {
    this.carregarDados();
  },
  methods: {
    carregarDados() {
      if (this.parametros) {
        this.payload.imprimirAbono = this.parametros.imprimirAbono;
        this.payload.imprimirAbonoBH = this.parametros.imprimirAbonoBH;
        this.payload.imprimirOcorrencia = this.parametros.imprimirOcorrencia;
        this.payload.imprimirBatidasManuais = this.parametros.imprimirBatidasManuais;
        this.payload.imprimirFeriado = this.parametros.imprimirFeriado;
      }
    },
    salvar() {
      this.payload.setDB = this.$cookies.get("db");
      this.$emit("salvarParametrizacao", this.payload);
    },
  },

  watch: {
    nome() {
      this.payload.razao_social = String(
        this.payload.razao_social,
      ).toUpperCase();
    },
    email() {
      this.payload.email = String(this.payload.email).toLowerCase();
    },
  },
};
</script>
